






































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import numeral from 'numeral';

interface IData {
  familyName: string,
  isSubFamily?: boolean,
  totalWithoutBigFleet: number,
  totalWithBigFleet: number,
  totalWithBigMid: number,
  isTotal?: boolean,
}

@Component({
  name: 'TableMethodologicalInfo'
})
export default class TableMethodologicalInfoComponent extends Vue {
  public numeral = numeral;

  @Prop({ required: true })
  public show: boolean;

  private toggleInfoModal() {
    this.$emit('toggleModal');
  }

  public get sourceData(): IData[] {
    return [
      {
        familyName: 'EX30',
        totalWithoutBigFleet: 0.031,
        totalWithBigFleet: 0.024,
        totalWithBigMid: 0.020,
      },
      {
        familyName: 'EC40',
        totalWithoutBigFleet: 0.046,
        totalWithBigFleet: 0.041,
        totalWithBigMid: 0.038,
      },
      {
        familyName: 'XC60',
        totalWithoutBigFleet: 0.266,
        totalWithBigFleet: 0.235,
        totalWithBigMid: 0.222,
      },
      {
        familyName: 'EX90',
        totalWithoutBigFleet: 0.199,
        totalWithBigFleet: 0.173,
        totalWithBigMid: 0.165,
      },
      {
        familyName: 'EX40',
        totalWithoutBigFleet: 0.052,
        totalWithBigFleet: 0.046,
        totalWithBigMid: 0.043,
      },
      {
        familyName: 'XC90',
        totalWithoutBigFleet: 0.043,
        totalWithBigFleet: 0.038,
        totalWithBigMid: 0.036,
      },
    ]
  }
}
